module.exports = __webpack_public_path__ + "img/mark_star_2_icon.c323bf78.png";